import React, { createContext, useContext } from 'react';
const BigContext = createContext(false);
const BigProvider = ({ children, value }) => (React.createElement(BigContext.Provider, { value: value }, children));
const useBig = () => useContext(BigContext);
export { BigProvider, useBig };
